module.exports = __webpack_public_path__ + "static/media/unapproved.b170f57a.svg";